import React, { useEffect, useState } from "react";
import Joi from "joi-browser";
import jwtDecode from "jwt-decode";
import { Link, useHistory } from "react-router-dom";
import { login } from "../../services/authService";
import { getModulos } from "../../services/modulosService";
import { getUser } from "../../services/userService";
import { useAuth } from "../../AuthContext";
import "./loginForm.css";

export default function LoginForm(props) {
  const [data, setData] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loginError, setLoginError] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);

  const history = useHistory();
  const { activeUser, loginUser, setModule } = useAuth();
  const schema = {
    username: Joi.string().email().required().label("Username"),
    password: Joi.string().required().label("Password"),
  };

  const handleSubmit = async () => {
    const { username, password } = data;
    setLoginError(false);
    setLoggingIn(true);
    try {
      const response = await login(username, password);
      if (response.data.success) {
        localStorage.setItem("token", response.data.token);
        const jwt = response.data.token;
        const decoded = jwt ? jwtDecode(jwt) : null;
        const user = await getUser(decoded.user._id);
        loginUser(user, response.data.token);
        const modulos = await getModulos();
        if (modulos) {
          let count = 0;
          let indexModuloUnico = null;
          modulos.map((modulo, index) => {
            if (user.empresa.modulos.find((item) => item === modulo._id)) {
              count++;
              indexModuloUnico = index;
            }
          });
          if (count === 1 && !user.empresa.muestraModulosInactivos) {
            const path = modulos[indexModuloUnico].path;
            setModule(path);
            history.replace("/" + path);
          } else {
            setModule(null);
            history.replace("/main");
          }
        } else {
          history.replace("/noconnection");
        }
      } else {
        setLoggingIn(false);
        setLoginError(true);
      }
    } catch (exception) {
      setLoginError(true);
    }
  };

  const handleChange = ({ currentTarget: input }) => {
    const _errors = { ...errors };
    const errorMessage = validateProperty(input);
    if (errorMessage) _errors[input.name] = errorMessage;
    else delete _errors[input.name];
    const _data = { ...data };
    _data[input.name] = input.value;
    setData(_data);
    setErrors(_errors);
  };

  const validateProperty = ({ name, value }) => {
    const object = { [name]: value };
    const _schema = { [name]: schema[name] };
    const { error } = Joi.validate(object, _schema);
    return error ? error.details[0].message : null;
  };

  const validate = () => {
    let errors = {};
    const options = { abortEarly: false };
    const { error } = Joi.validate(data, schema, options);
    if (!error) return null;
    error.details.map((validationError) => {
      return (errors[validationError.path[0]] = validationError.message);
    });
    return errors;
  };

  if (activeUser) {
    return null;
  }

  return (
    <div id="login">
      <div id="login-intro">
        <div className="logo scale-up-center">
          <img src="/dist/img/logo.svg" />
        </div>
        <div className="title slide-in-blurred-left">Khios WEB v2.00</div>
        <div className="description slide-in-blurred-left">
          Sistema integral de gestión inmobiliaria. Ingrese sus credenciales de acceso para ingresar al sistema.
        </div>
      </div>
      <div id="login-form-wrapper" className="slide-left">
        <div id="login-form">
          <div className="logo">
            <img src="/dist/img/logo.svg" />
          </div>
          <div className="title">ACCESO AL SISTEMA</div>
          <div className="form-label-group">
            <input
              type="email"
              id="username"
              name="username"
              placeholder="e-mail"
              value={data.username}
              error={errors["username"]}
              className={errors["username"] ? "login-input form-control invalid" : "login-input form-control"}
              onChange={handleChange}
              autoFocus
            />
            <label className="login-label" htmlFor="username">
              Correo electrónico
            </label>
          </div>
          <div className="form-label-group">
            <input
              type="password"
              id="password"
              name="password"
              className={errors["password  "] ? "login-input form-control invalid" : "login-input form-control"}
              placeholder="Contraseña"
              value={data.password}
              error={errors["password"]}
              onChange={handleChange}
            />
            <label className="login-label" htmlFor="password">
              Contraseña
            </label>
          </div>
          {loggingIn && (
            <div className="preloaderlogin justify-content-center align-items-center">
              <i className="mt-5 text-secondary fas fa-2x fa-sync fa-spin"></i>
            </div>
          )}
          {!loggingIn && (
            <div>
              <div className="remember-forgot-password">
                <div className="remember-me-container">
                  <input type="checkbox" id="rememberMe" name="rememberMe" className="remember-me" />
                  Recordarme
                </div>
                <Link to="/forgotpassword" className="forgot-password ">
                  Olvidó su contraseña?
                </Link>
              </div>

              {loginError && <div className="invalid-login">Usuario o contraseña incorrecta</div>}
              {!loginError && <div className="invalid-login">{"    "}</div>}

              <button
                id="btnLogin"
                disabled={validate()}
                onClick={handleSubmit}
                className="btn btn-lg btn-secondary btn-block btn-login text-uppercase font-weight-bold mb-2"
              >
                INGRESAR
              </button>

              <div className="register">
                <span className="text">No tiene una cuenta?</span>
                <a className="clickable">Crear una cuenta</a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
